import * as API from "./api";
import * as Types from "./Types";

export function tryCreateCommunity(token, data) {
  return dispatch => {
    dispatch({
      type: Types.CREATE_COMMUNITY
    });

    API.createCommunity(token, data)
      .then(response => {
        dispatch({
          type: Types.CREATE_COMMUNITY_SUCCESS,
          payload: response.data.data
        });
      })
      .catch(error => {
        dispatch({
          type: Types.CREATE_COMMUNITY_FAILED
        });
      });
  };
}

export function tryUpdateCommunity(token, id, data) {
  return dispatch => {
    dispatch({
      type: Types.UPDATE_COMMUNITY
    });

    API.updateCommunity(token, id, data)
      .then(response => {
        dispatch({
          type: Types.UPDATE_COMMUNITY_SUCCESS,
          payload: response.data.data
        });
      })
      .catch(error => {
        dispatch({
          type: Types.UPDATE_COMMUNITY_FAILED
        });
      });
  };
}

export function tryDeleteCommunity(token, id) {
  return dispatch => {
    dispatch({
      type: Types.DELETE_COMMUNITY
    });

    API.deleteCommunity(token, id)
      .then(response => {
        dispatch({
          type: Types.DELETE_COMMUNITY_SUCCESS,
          payload: id
        });
      })
      .catch(error => {
        dispatch({
          type: Types.DELETE_COMMUNITY_FAILED
        });
      });
  };
}

export function tryGetCommunities(token) {
  return dispatch => {
    dispatch({
      type: Types.GET_COMMUNITIES
    });

    API.getCommunities(token)
      .then(response => {
        dispatch({
          type: Types.GET_COMMUNITIES_SUCCESS,
          payload: response.data.data
        });
      })
      .catch(error => {
        dispatch({
          type: Types.GET_COMMUNITIES_FAILED
        });
      });
  };
}

export function tryCreateAppartment(token, id, data) {
  return dispatch => {
    dispatch({
      type: Types.CREATE_APPARTMENT
    });

    return API.createAppartment(token, id, data)
      .then(response => {
        dispatch({
          type: Types.CREATE_APPARTMENT_SUCCESS,
          payload: response.data.data
        });
      })
      .catch(error => {
        dispatch({
          type: Types.CREATE_APPARTMENT_FAILED
        });
      });
  };
}
export function tryDeleteAppartment(token, id, appartmentId) {
  return dispatch => {
    dispatch({
      type: Types.DELETE_APPARTMENT
    });

    return API.deleteAppartment(token, id, appartmentId)
      .then(response => {
        dispatch({
          type: Types.DELETE_APPARTMENT_SUCCESS,
          payload: response.data.data
        });
      })
      .catch(error => {
        dispatch({
          type: Types.DELETE_APPARTMENT_FAILED
        });
      });
  };
}



// WEBPACK FOOTER //
// ./src/components/actions/Communities.js